import React, { Component } from "react";
import { Div, Text } from "atomize";

import AnimateLink from "../common/AnimateLink";
import ImageLazyLoad from "../common/ImageLazyLoad";
import ImageLink from "./ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

class BlogCard extends Component {
  render() {
    const { content, ...rest } = this.props;

    return (
      <a href={`/blog/${content.node.slug}`}>
        <Div {...rest} className="card-animation" cursor="pointer" bg="white">
          <Div pos="relative" p={{ b: "120.3%" }}>
            <Div
              pos="absolute"
              top="0"
              left="0"
              right="0"
              bottom="0"
              d="flex"
              flexDir="column"
            >
              <ImageLazyLoad
                className="image-card"
                bgImg={content.node.featured_image.data.url}
                bgSize="cover"
                bgPos="center"
                p={{ b: "56.3%" }}
              />
              <Div
                textAlign="center"
                textColor="black"
                p="1rem"
                flexGrow="1"
                d="flex"
                flexDir="column"
                align="center"
              >
                <Text
                  textSize={{ xs: "tiny", lg: "caption1" }}
                  textTransform="uppercase"
                  textWeight="700"
                  className="text-gradient"
                  m={{ b: { xs: "0.75rem", xl: "1rem" }, t: "1rem" }}
                  style={{ letterSpacing: "1.5px" }}
                >
                  Podcast
                </Text>
                <Text
                  textSize="paragraph2"
                  maxW={{ xs: "12.01rem", lg: "16rem", xl: "20rem" }}
                  textWeight="700"
                >
                  {content.node.title}
                </Text>
              </Div>
            </Div>
          </Div>
        </Div>
      </a>
    );
  }
}

export default BlogCard;
